import React from "react";
import Grid from "@material-ui/core/Grid";
import CustomAlert from "../CustomAlert";
import { isPaperGradesAvailable } from "../../utils";
import Report from "./Report";
import CustomCardItem from "../Cards/CustomCardItem";
import { Typography } from "@material-ui/core";

const Reports = ({ reports }) => {

    return (
        // Ver se é hoje que tem e se pode mostrar

        <Grid item xs={12}>
            {
                !isPaperGradesAvailable() ?
                    <CustomAlert message="Avaliações não disponíveis" />
                    :
                    <>
                        {
                            !reports.length ?
                                <CustomAlert message="Não há avaliações." />
                                :
                                <>
                                    <CustomCardItem>
                                        <Typography variant="h3">Avaliações</Typography>
                                        {
                                            reports.map((r, i) => (
                                                <Report accessCodes={false} key={i + 'x'} report={r} />
                                            ))
                                        }
                                    </CustomCardItem>
                                </>
                        }
                    </>
            }
        </Grid>
    )
}

export default Reports
